import { apiClient } from './api'

export interface LastSeenRelease {
  version: string | null
  seen_at: string | null
}

export async function fetchLastSeenRelease(): Promise<LastSeenRelease> {
  const response = await apiClient.get<LastSeenRelease>('/user/last-seen-release')
  return response.data
}

export async function markReleaseSeen(version: string): Promise<LastSeenRelease> {
  const response = await apiClient.post<LastSeenRelease>(
    '/user/last-seen-release',
    { version },
  )
  return response.data
}
